const TONE: Record<string, string> = {
  completed: "ok",
  done: "ok",
  awaiting_review: "review",
  awaiting_confirmation: "info",
  parsing: "info",
  extracting: "info",
  queued: "info",
  failed: "fail",
  not_found: "fail",
};

export function Pill({ value }: { value: string }) {
  return <span className={`pill ${TONE[value] ?? "info"}`}>{value.replace(/_/g, " ")}</span>;
}
